/* eslint-disable no-nested-ternary */
import React from 'react';
import { Route } from 'react-router-dom';

import LayoutUser from './layout/UserLayout';

type PrivateRouteProps = {
  children: JSX.Element;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  ...rest
}: PrivateRouteProps): JSX.Element => {
  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={({ location }) => <LayoutUser>{children}</LayoutUser>}
    />
  );
};

export default PrivateRoute;
